import type { ComponentType } from 'react'
import type { WidgetKey } from '@/types/dashboard'
import type { WidgetProps } from './WidgetProps'
import { TodayScheduleWidget } from './TodayScheduleWidget'
import { NextLessonsWidget } from './NextLessonsWidget'
import { PendingPaymentsWidget } from './PendingPaymentsWidget'
import { SubscriptionsExpiringWidget } from './SubscriptionsExpiringWidget'
import { BirthdaysWidget } from './BirthdaysWidget'
import { ActivityHeatmapWidget } from './ActivityHeatmapWidget'
import { CardsProgressWidget } from './CardsProgressWidget'
import { NewsWidget } from './NewsWidget'
import { TestsToCheckWidget } from './TestsToCheckWidget'
import { HomeworksToCheckWidget } from './HomeworksToCheckWidget'
import { NextLessonWidget } from './NextLessonWidget'
import { PendingHomeworksWidget } from './PendingHomeworksWidget'
import { PendingTestsWidget } from './PendingTestsWidget'
import { StreakWidget } from './StreakWidget'
import { SubscriptionStatusWidget } from './SubscriptionStatusWidget'
import { RecentResultsWidget } from './RecentResultsWidget'

/**
 * Реестр компонентов виджетов по widget_key. Ключи без компонента
 * (зарезервированные под будущие модули, например achievements_recent)
 * рендерятся заглушкой EmptyHint в RoleDashboard.
 */
export const WIDGET_COMPONENTS: Partial<Record<WidgetKey, ComponentType<WidgetProps>>> = {
  today_schedule: TodayScheduleWidget,
  next_lessons: NextLessonsWidget,
  pending_payments: PendingPaymentsWidget,
  subscriptions_expiring: SubscriptionsExpiringWidget,
  birthdays: BirthdaysWidget,
  students_activity_heatmap: ActivityHeatmapWidget,
  cards_progress: CardsProgressWidget,
  news: NewsWidget,
  tests_to_check: TestsToCheckWidget,
  homeworks_to_check: HomeworksToCheckWidget,
  next_lesson: NextLessonWidget,
  pending_homeworks: PendingHomeworksWidget,
  pending_tests: PendingTestsWidget,
  streak: StreakWidget,
  subscription_status: SubscriptionStatusWidget,
  recent_results: RecentResultsWidget,
}
